import React from 'react'
// import { Spin } from 'antd'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'
import useStore from '../stores/useStore'
import Icon from '@ant-design/icons'
import { ReactComponent as SignInLogoSvg } from '../assets/svg/signin_logo.svg'
import { ReactComponent as LoadingSvg } from '../assets/svg/loading_ellipsis.svg'

type TLoadingPage = {
    loading: boolean
}

const LoadingContainer = styled.div({
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 100000,
    cursor: 'wait',
    overflow: 'hidden',
    backgroundColor: 'rgb(0 0 0 / 50%)',
})

const Loading = styled.div({
    position: 'relative',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    maxWidth: '400px',
    minWidth: '150px',
    top: '50%',
    left: '50%',
})

export let LoadingPageView: React.FC<TLoadingPage> = ({ loading = false }) => {
    if (loading) {
        return (
            <LoadingContainer>
                <Loading>
                    <Icon
                        component={SignInLogoSvg}
                        style={{
                            fontSize: '15rem',
                            margin: '0px',
                            position: 'absolute',
                            transform: 'translate(-50%, -50%)',
                            top: '25%',
                            left: '50%',
                        }}
                    />
                    <Icon
                        component={LoadingSvg}
                        style={{
                            margin: '0px',
                            position: 'absolute',
                            transform: 'translate(-50%, -25%)',
                            top: '50%',
                            left: '50%',
                            fontSize: '20rem',
                        }}
                    />
                </Loading>
            </LoadingContainer>
        )
    } else {
        return null
    }
}
LoadingPageView = observer(LoadingPageView)

let LoadingPage: React.FC = () => {
    const { loadingStore } = useStore()
    return <LoadingPageView loading={loadingStore.loading} />
}

LoadingPage = observer(LoadingPage)

export default LoadingPage
